module.exports = "/images/preview.svg?c8fc844d0fb514c9088c615bf2c95a3c";